import Vue from 'vue'
import SignupPage from "./components/SignupPage";


new Vue({
  render: h => h(SignupPage),
}).$mount('#signup__form');
